import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { getInfoTatica, getMissao } from "~services/RoteirizacaoServices";
import apiGenericClient from "~services/utils/apiGenericClient";
import { marcarClienteEscritorio } from "~services/FunnelService";

export const useSaveVisita = (onSuccessCloseModal, onErrorCloseModal) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async (camposVisita, { escritorio = false } = {}) => {
    setIsLoading(true);

    try {
      const clienteId = camposVisita?.checkOut?.clienteId;

      if (escritorio) {
        await marcarClienteEscritorio(clienteId);
      }
      const client = new apiGenericClient("roteirizacao", "/api/Visita");
      const response = await client.createData(camposVisita);


      if (response?.data?.isOffline) {
        onSuccessCloseModal?.(response, true);
        return;
      }


      if (response?.isSuccess === false) {
        throw new Error(response?.message ?? "Não foi possível salvar a visita");
      }

      onSuccessCloseModal?.(response, false);
    } catch (error) {
      console.error("Erro ao salvar visita:", error);
      onErrorCloseModal?.(error);

      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return { handleSave, isLoading };
};

export const useSaveVisitas = (onSuccess, onError) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async (camposVisita) => {
    setIsLoading(true);

    try {
      const client = new apiGenericClient("roteirizacao", "/api/Visita/Todas");
      const response = await client.createData(camposVisita);

      // Se a resposta indica que foi salvo offline, trata como sucesso offline
      if (response?.data?.isOffline) {
        onSuccess?.(response, true); // true indica que está offline
      } else {
        onSuccess?.(response, false); // false indica sucesso online
      }
    } catch (error) {
      console.error("Erro ao salvar visitas:", error);
      onError?.(error);
    } finally {
      setIsLoading(false);
    }
  };

  return { handleSave, isLoading };
};

export const useGetMissoes = (enabled, clienteId) => {
  const { data, error, isLoading, isSuccess } = useQuery(["missoes-cliente", clienteId], () => getMissao(clienteId), {
    enabled,
  });

  return { data, error, isLoading, isSuccess };
};

export const useGetInfoTaticas = (enabled, clienteId) => {
  const { data, error, isLoading, isSuccess } = useQuery(
    ["info-taticas-cliente", clienteId],
    () => getInfoTatica(clienteId),
    {
      enabled,
    }
  );

  return { data, error, isLoading, isSuccess };
};
